import { type IProfile } from '../features/profile/profile';

export const getProfileFullName = (profile?: IProfile | null) => {
    if (!profile) {
        return '';
    }

    return `${profile.first_name} ${profile.last_name}`;
};
